/* eslint-disable import/prefer-default-export */
import { createContext } from 'react'

export const MenuContext = createContext<{
  opened: boolean
  activeIndex: number | null
  setOpened: (opened: boolean) => void
  setActiveIndex: React.Dispatch<React.SetStateAction<number | null>>
  getItemProps: (userProps?: React.HTMLProps<HTMLElement>) => Record<string, unknown>
  preventCloseOnItemClick?: boolean
}>({
  opened: false,
  preventCloseOnItemClick: false,
  activeIndex: null,
  setOpened: () => ({}),
  setActiveIndex: () => ({}),
  getItemProps: () => ({}),
})
